export default __webpack_public_path__ + "static/media/pic3.9239c281.jpg";